import React, { useContext, useEffect } from "react";
import useCapabilityContext from "./context/useCapabilityContext";
import { getStationRefreshInterval } from "../util/Util";
import RouteViewTable from "./RouteViewTable";
import { RouteFilterContext } from "./context/RouteFilterContext";
import { RouteStatusContext } from "./context/RouteStatusContext";
import { LOAD_VIEW } from "./utils/ReducerActionTypes";

const RouteStatusTable = (props) => {
  const { dispatch } = useContext(RouteStatusContext);
  const { dispatchF } = useContext(RouteFilterContext);
  const { configViewModel, configDispatch, configViewModelRef } =
    useCapabilityContext();

  const getRouteData = () => {
    const config = configViewModelRef.current;
    if (config.stationConfig.initialised) {
      dispatch({
        type: LOAD_VIEW,
        data: {
          dispatcher: dispatch,
          filterDispatcher: dispatchF,
          baseUrl: config.baseUrl,
          capability: config.capability,
          stationConfig: config.stationConfig,
          configDispatch: configDispatch,
        },
      });
    }
  };

  /**
   * This gets invoked on following events:
   *  1. On every page load,
   *  2. Every time filter value is changed,
   *  3. When station config's initialised attribute changes - usually happens when NodeConfig API response is received.
   *  Note: Updates on station config does not re-render useEffect, if initialised attribute value is not changed.
   */
  useEffect(() => {
    getRouteData();
    let firstPollTime = getStationRefreshInterval(
      configViewModelRef.current.stationConfig,
    );

    const timeoutHandler = () => {
      getRouteData();
      timeout = setTimeout(
        timeoutHandler,
        getStationRefreshInterval(configViewModelRef.current.stationConfig),
      );
    };
    let timeout = setTimeout(timeoutHandler, firstPollTime);

    return () => clearTimeout(timeout);
  }, [configViewModel.stationConfig.initialised]);

  return (
    <div>
      <div>
        <RouteViewTable history={props.history} />
      </div>
    </div>
  );
};

export default RouteStatusTable;



// WEBPACK FOOTER //
// ./src/components/RouteStatus/RouteStatusTable.js